const Star = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path
      fill='none'
      fillRule='evenodd'
      stroke='#000'
      strokeWidth='1.5'
      d='M7.075 21.16L12 18.46l4.925 2.701c.532.292 1.172-.193 1.062-.86l-.933-5.68 3.96-4.027c.461-.47.204-1.293-.405-1.386l-5.497-.833-2.453-5.186c-.276-.584-1.042-.584-1.318 0L8.888 8.374l-5.497.833c-.61.093-.866.917-.404 1.386l3.96 4.028-.934 5.679c-.11.667.53 1.152 1.062.86z'
    />
  </svg>
);

export default Star;
